module.exports = new __parcel__URL__("Sales Portal Hover.f29ecdcb.svg").toString();